import * as React from "react";
import { PureComponent } from "react";

export default class CityInfo extends PureComponent {
  render() {
    const { info } = this.props;
    return (
      <div>
        <div style={{}}>
          {info.name}地点 <br />
          <br /> 平均濃度: {info.concentration}ppm
        </div>
        <p
          style={{
            textAlign: "center",
            border:
              info.concentration > 1000 && info.concentration < 1900
                ? "2px #fbc02d solid"
                : info.concentration > 1900
                ? "2px #c62828 solid"
                : "",
            borderRadius: "6px",
          }}
        >
          {info.concentration > 1400 && "高濃度注意"}
          {info.concentration < 1000 && "良好です"}
        </p>
      </div>
    );
  }
}
